import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const AbituriyentIdWrapper = styled.div`
  background: #f5f7fa;
  padding: 60px 0 80px;
  animation: ${fadeIn} 0.5s ease both;

  .container {
    .hero-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 48px;
      align-items: start;
      margin-bottom: 48px;

      .img-box {
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(21, 82, 61, 0.18);

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(
            160deg,
            rgba(21, 82, 61, 0.08) 0%,
            transparent 50%
          );
          z-index: 1;
          border-radius: 20px;
        }

        img {
          width: 100%;
          height: 480px;
          object-fit: cover;
          display: block;
          border-radius: 20px;
          transition: transform 0.5s ease;

          &:hover {
            transform: scale(1.03);
          }
        }

        .img-badge {
          position: absolute;
          bottom: 20px;
          left: 20px;
          background: rgba(21, 82, 61, 0.9);
          backdrop-filter: blur(8px);
          color: #fff;
          font-family: "Montserrat", sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          padding: 8px 18px;
          border-radius: 30px;
          z-index: 2;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }

      .info-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-top: 8px;

        .tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(21, 82, 61, 0.1);
          color: #15523d;
          font-family: "Montserrat", sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1.2px;
          text-transform: uppercase;
          padding: 6px 16px;
          border-radius: 30px;
          width: fit-content;

          svg {
            flex-shrink: 0;
          }
        }

        .title-box h3 {
          font-family: "Montserrat", sans-serif;
          font-weight: 800;
          font-size: 28px;
          line-height: 1.3;
          color: #0f2d1f;
          margin: 0;
        }

        .divider {
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #15523d, #1e7a58);
          border-radius: 4px;
        }

        .content-box p {
          font-family: "Montserrat", sans-serif;
          font-weight: 400;
          font-size: 16px;
          line-height: 1.8;
          color: #444;
          margin: 0;
        }

        .stats-row {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;

          .stat-card {
            background: #fff;
            border: 1px solid #e8eeeb;
            border-radius: 14px;
            padding: 16px 22px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            box-shadow: 0 2px 12px rgba(21, 82, 61, 0.07);
            flex: 1;
            min-width: 120px;

            .stat-label {
              font-family: "Montserrat", sans-serif;
              font-size: 11px;
              font-weight: 600;
              color: #888;
              text-transform: uppercase;
              letter-spacing: 0.8px;
            }

            .stat-value {
              font-family: "Montserrat", sans-serif;
              font-size: 22px;
              font-weight: 800;
              color: #15523d;
            }
          }
        }
      }
    }

    .full-content {
      background: #fff;
      border-radius: 20px;
      padding: 40px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border: 1px solid #eaf0ec;

      p,
      li,
      td,
      th {
        font-family: "Montserrat", sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 1.8;
        color: #333;
      }

      h1, h2, h3, h4 {
        font-family: "Montserrat", sans-serif;
        font-weight: 700;
        color: #0f2d1f;
        margin: 24px 0 12px;
      }

      img {
        max-width: 100%;
        border-radius: 12px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 16px 0;

        th {
          background: linear-gradient(135deg, #15523d, #1e7a58);
          color: #fff;
          padding: 12px 16px;
          font-weight: 700;
        }

        td {
          padding: 10px 16px;
          border-bottom: 1px solid #edf2ee;
        }

        tr:hover td {
          background: #f3f8f5;
        }
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    padding: 40px 0 60px;

    .container .hero-section {
      grid-template-columns: 1fr;
      gap: 28px;

      .img-box img {
        height: 380px;
      }

      .info-box .title-box h3 {
        font-size: 22px;
      }
    }

    .container .full-content {
      padding: 28px;
    }
  }

  @media only screen and (max-width: 700px) {
    padding: 24px 0 48px;

    .container .hero-section {
      gap: 20px;

      .img-box img {
        height: 260px;
      }

      .info-box .title-box h3 {
        font-size: 18px;
      }

      .info-box .content-box p {
        font-size: 14px;
      }

      .info-box .stats-row {
        gap: 10px;
      }
    }

    .container .full-content {
      padding: 20px 16px;
      border-radius: 14px;

      p, li, td, th {
        font-size: 14px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .container .hero-section .img-box img {
      height: 220px;
    }

    .container .hero-section .info-box .title-box h3 {
      font-size: 16px;
    }
  }
`;